import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    disableLicensesModules,
    getDisabledLicensesModulesProgress,
    stopDisableLicensesModulesAction,
} from 'src/openapi/admin/apis/BulkLicensesModulesApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {DisableModuleLicenseModal} from './license-access-module-disable.modal';
import {
    selectLicenseAccessModuleDisableResultTask,
    selectLicenseAccessModuleDisableResultUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from './license-access-module-disable.slice';

import type {LicenseBulkUpdateRequest} from 'src/openapi/admin/models/LicenseBulkUpdateRequest';

type Props = {
    shown: boolean,
    accountIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const LicenseAccessModuleDisableTool = ({shown, accountIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<LicenseBulkUpdateRequest>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectLicenseAccessModuleDisableResultTask}
            uuidSelector={selectLicenseAccessModuleDisableResultUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(licenseBulkUpdateRequest, options) => (
                apiDispatch(disableLicensesModules({...options, licenseBulkUpdateRequest}))
            )}
            getProgress={id => apiDispatch(getDisabledLicensesModulesProgress({id}))}
            stopAction={id => apiDispatch(stopDisableLicensesModulesAction({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <DisableModuleLicenseModal {...{accountIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
